import colors, { palette } from './colors';
import fonts from './fonts';
import shadows from './shadows';

const theme = {
  colors,
  palette,
  fonts,
  shadows,
  fontSizes: fonts.fontSizes,
  headerSize: '60px',
  footerSize: '100px',
};

export default theme;
